import { appFeature } from 'modules/organizer/domain/interfaces/available-feature';
import { Pages } from 'modules/navigation/domain/enums/pages';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFeature } from 'shared/hooks/use-feature';

type FeatureRouteProps = {
  children: JSX.Element;
  feature: appFeature;
  fallback?: string;
};

const FeatureRoute = React.memo((props: FeatureRouteProps) => {
  const { children, feature, fallback = Pages.INDEX } = props;
  const { isEnabled, isFetching } = useFeature(feature);

  if (isFetching) return null;
  if (!isEnabled) return <Navigate to={fallback} />;
  return children;
});

export default FeatureRoute;
